import React, { useState } from 'react'
import HomeLayout from '../layouts/HomeLayout'
import AppInput from '../components/formik/AppInput'
import { Formik } from 'formik'
import * as Yup from 'yup'
import HomeSubmit from '../components/formik/HomeSubmit'
import HomeTextArea from '../components/formik/HomeTextArea'
import instance from '../api/client'
import { Link, useNavigate } from 'react-router-dom'
import authService from '../authentication'
import AppContext from '../contexts/AppContext'
import { useContext } from 'react'
import jwtDecode from 'jwt-decode';
import { toast } from 'react-toastify';
import { ChevronLeft } from 'react-feather'
import Loader from '../components/loaders/Loader'
import { COUNTRIES } from '../components/country-picker/COUNTRIES';
import CountrySelector from '../components/country-picker/CountrySelector'

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required().label("First name"),
  lastName: Yup.string().required().label("Last name"),
  otherNames: Yup.string().required().label("Other"),
  organization: Yup.string().required().label("Organization"),
  city: Yup.string().required().label("City"),
  street: Yup.string().required().label("Street"),
  bio: Yup.string().required().label("Bio"),
  username: Yup.string().required().label("Username"),
  email: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(6).label("Password"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

export default function Signup() {
  const [isAdmin, setIsAdmin] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [country, setCountry] = useState('GH')
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const { setUser } = useContext(AppContext)
  const [currentSlide, setcurrentSlide] = useState(1);

  const onSubmit = async (form, { resetForm }) => {
    delete form.confirmPassword;
    try {
      setLoading(true)
      const { data, status } = await instance.post('/user/signup', { ...form, country })
      authService.setCurrentUser(data.token)
      setUser(jwtDecode(data.token))
      toast.success("Account created successfully", {
        position: toast.POSITION.TOP_CENTER
      });
      navigate('/dashboard')

    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  };


  const handleClick = (formik) => {
    if (currentSlide === 1) {
      const isfirstInvalid = formik.errors.firstName || formik.errors.lastName || formik.errors.otherNames || formik.errors.organization || formik.errors.email || !(formik.values.firstName || formik.values.lastName || formik.values.otherNames || formik.values.organization || formik.values.email);

      if (!isfirstInvalid) return next();
    }
    else if (currentSlide === 2) {
      const issecondInvalid = formik.errors.username || formik.errors.password || formik.errors.confirmPassword || !(formik.values.username || formik.values.password || formik.values.confirmPassword);

      if (!issecondInvalid) return next();
    }
    else if (currentSlide === 3) {
      const isthirdInvalid = formik.errors.city || formik.errors.street || !(formik.values.city || formik.values.street);

      if (!isthirdInvalid) return next();
    }
    else { return null; }
  }



  const next = () => {
    if (currentSlide > 4) { setcurrentSlide(4); }
    else { setcurrentSlide(currentSlide + 1); }
  };

  const prev = () => {
    if (currentSlide < 1) { setcurrentSlide(1); }
    else { setcurrentSlide(currentSlide - 1); }
  };

  return (
    <>
      {loading &&
        <div style={{}} className='absolute z-50 flex w-full h-full items-center justify-center bg-modal'>
          <div className=' flex items-center justify-center'>
            <Loader animationName={'infinitywhite'} height={300} width={400} />
          </div>
        </div>
      }
      <HomeLayout>


        {/*HOMELAYOUT2*/}
        <div className='mb-2 text-2xl text-center font-bold md:text-3xl capitalize'>
          Create an account
        </div>
        <div className='w-1/4 h-[2.5px] bg-slate-700 mx-auto mb-5' />
        <Formik
          initialValues={{
            firstName: '', lastName: '', otherNames: '', username: '', email: '', organization: '',
            city: '', street: '',
            password: '', confirmPassword: '', bio: ''
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {formik => (
            <div className='px-20'>
              <button onClick={() => { prev() }} className={`${currentSlide === 4 ? "" : "hidden"} bg-slate-700 text-slate-300 rounded-l-md mt-10 hover:text-white hover:scale-[1.07] duration-300`}><ChevronLeft size={30} /></button>

              <div className={`transition-all ease-in-out duration-3000 slide transform -translate-x-${(currentSlide - 1) * 100}%`}>
                <div className={`gap-4 w-full ${currentSlide <= 1 ? "block" : "hidden"}`}>
                  <div className='flex gap-3'>
                    <AppInput boxClassName={'w-1/2'} label={'first name'} name={'firstName'} placeholder={'John'} type={'text'} />
                    <AppInput boxClassName={'w-1/2'} label={'last name'} name={'lastName'} placeholder={'Doe'} type={'text'} />
                  </div>
                  <AppInput label={'other names'} name={'otherNames'} placeholder={'Jenkins'} type={'text'} />
                  <AppInput label={'organization'} name={'organization'} placeholder={'What Organisation are you signing up under?'} type={'text'} />
                  <AppInput label={'email'} name={'email'} placeholder={'someone@example.com'} type={'email'} />

                </div>

                <div className={`gap-4 w-full mt-20 ${currentSlide === 2 ? "block" : "hidden"}`}>
                  <AppInput label={'username'} name={'username'} placeholder={'user'} type={'text'} />
                  <AppInput label={'password'} name={'password'} placeholder={'*******'} type={'password'} />
                  <AppInput label={'confirm password'} name={'confirmPassword'} placeholder={'*******'} type={'password'} />

                </div>

                <div className={`gap-4 w-full mt-32 ${currentSlide === 3 ? "block" : "hidden"}`}>
                  <div className=''>
                    <label className={`block text-gray-800 text-sm mb-2 capitalize`} for={'countries'}>
                      Country of origin
                    </label>
                    <CountrySelector
                      id={'countries'}
                      open={isOpen}
                      onToggle={() => setIsOpen(!isOpen)}
                      onChange={val => setCountry(val)}
                      // We use this type assertion because we are always sure this find will return a value but need to let TS know since it could technically return null
                      selectedValue={COUNTRIES.find(option => option.value === country)}
                    />
                  </div>
                  <AppInput label={'city'} name={'city'} placeholder={'city'} type={'text'} />
                  <AppInput label={'street'} name={'street'} placeholder={'street'} type={'text'} />
                </div>

                <div className={`gap-4 w-full mt-32 ${currentSlide === 4 ? "block" : "hidden"}`}>
                  <HomeTextArea name={'bio'} label={'Bio'} placeholder={'Tell us something about yourself'} />
                </div>

              </div>


              <div className={`flex mt-10  ${currentSlide >= 4 ? "hidden" : "block"}`}>
                <button onClick={() => { prev() }} className={`${currentSlide === 1 ? "hidden" : ""} ${currentSlide === 5 ? "hidden" : ""} bg-slate-700 text-slate-300 rounded-l-lg hover:text-white hover:scale-[1.07] duration-300`}><ChevronLeft size={40} /></button>
                <button className={` w-full text-white text-xl bg-theme hover:font-semibold hover:scale-[1.02] duration-300 ${currentSlide === 1 ? "py-2" : "ml-1"} ${currentSlide === 5 ? "hidden" : ""} `} onClick={() => { handleClick(formik) }}>Continue</button>
              </div>


              <div className={`mt-10 w-full flex justify-start font-semibold ${currentSlide === 4 ? "block" : "hidden"}`}>
                <HomeSubmit theme text={'Create Account'} />
              </div>

              <div className='mt-8 flex items-center justify-center inset-x-0 bottom-0'>
                <div className={`text-md text-center p-3 ${currentSlide >= 4 ? "hidden" : "inline"}`}>
                  <span>Already have an account?
                    <Link to={'/login'} className={`font-semibold`}> Log In</Link>
                  </span>
                </div>
              </div>
            </div>
          )}
        </Formik>

      </HomeLayout>
    </>
  )
}
